import React, { useState, useCallback } from 'react'
import { useStyles } from './styles'
import clsx from 'clsx'

interface ReadMoreProps {
    text: string
    limit: number
    className?: string
    showMoreText?: string
    showLessText?: string
    ending?: string
}

const ReadMore: React.FC<ReadMoreProps> = ({
    text,
    limit,
    className = '',
    showMoreText = 'Read More',
    showLessText = 'Show Less',
    ending = '... ',
}) => {
    const classes = useStyles()

    const [showMoreLink, setShowMoreLink] = useState(text.length > limit)

    const onShowMore = useCallback(() => {
        setShowMoreLink(false)
    }, [])

    const onShowLess = useCallback(() => {
        setShowMoreLink(true)
    }, [])

    const ShowLess = (
        <p className={clsx(className, classes.text)}>
            {text}{' '}
            <button className={classes.readMore} onClick={onShowLess}>
                {showLessText}
            </button>
        </p>
    )

    if (text.length <= limit) {
        return <p className={clsx(className, classes.text)}>{text}</p>
    }

    if (showMoreLink) {
        return (
            <p className={clsx(className, classes.text)}>
                {text.substring(0, limit - ending.length)}
                {ending}
                <button className={classes.readMore} onClick={onShowMore}>
                    {showMoreText}
                </button>
            </p>
        )
    }

    return ShowLess
}

export default React.memo(ReadMore)
